import { defineCustomElement } from "vue";

import DnlImage from "@/components/archive/DpaNewsDetailPage/DpaNewsDetailPageStory/DnlElements/DnlImage.vue";
const config = {
  shadowRoot: false,
};

customElements.define("dnl-image", defineCustomElement(DnlImage, config));
